/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import moment from 'moment';
import {useRouter} from 'next/router';

import Link from '../../components/Link';
import {RightArrowIcon} from '../../components/svg';
import {useAnalytics} from '../../hooks';

const GuideCard = ({guide, tag}) => {
  const {tracker} = useAnalytics();
  const router = useRouter();
  const url = `/guides/${guide.slug}`;

  const handleClick = () => {
    tracker.hubClickCard({type: 'guides', tag: tag.id, slug: guide.slug});
    router.push(url);
  };

  return (
    <div
      onClick={handleClick}
      className="cursor-pointer py-3 px-5 border border-gray-200 rounded-lg hover:border-gray-300 transition duration-50 flex flex-col justify-between"
    >
      <div className="mb-2">
        <Link href={url}>
          <h3 className="text-xl font-semibold text-gray-900">
            {guide.roleName || guide.name}
          </h3>
        </Link>
        <span className="block text-sm font-medium text-gray-500">
          {guide.updatedAt && `Updated ${moment(guide.updatedAt).fromNow()}`}
        </span>
      </div>
      <span className="text-indigo text-sm font-semibold ml-auto">
        View guide
        <RightArrowIcon className="w-4 ml-1.5" />
      </span>
    </div>
  );
};

export default GuideCard;
